import { PlanOfferDetail } from '../typings';
import {
  constructPriceAttributes,
  constructPromotionAttributes,
} from './productAttributes.utils';

export const constructPlanProduct = (plan: PlanOfferDetail) => ({
  productInfo: {
    productID: plan?.id,
    productName: plan?.name,
    manufacturer: 'Spark',
    sku: 'plan.externalId', // TBC
  },
  category: {
    primaryCategory: plan.dataLayerCategory,
  },
  attributes: {
    displayName: plan?.name,
    bundleType: '', // TBC
    ...constructPriceAttributes(plan?.price),
    ...constructPromotionAttributes(plan?.promotions),
    subscriptionInfo: {
      isUnlimitedData: false, // TBC
    },
  },
});

export const constructPlanCardImpressionData = (
  planOption: PlanOfferDetail,
) => ({
  event: [
    {
      eventInfo: {
        eventName: 'Component View',
        eventAction: 'component.view',
      },
    },
  ],
  component: [
    {
      componentInfo: {
        componentID: 'shop.productDetails.chooseAPlan',
        componentName: 'Product Details Choose a Plan',
      },
      category: {
        primaryCategory: planOption.category?.[0]?.id,
        subCategory1: planOption.category?.[1]?.id,
      },
    },
  ],
  product: [constructPlanProduct(planOption)],
});
